import $ from 'jquery';
import LocationUtil from '@lts-web/utils/LocationUtil';
import SearchModuleUtil from "@lts-web/utils/SearchModuleUtil";

const __GDSLocations__ = [];

$.LocationUtil = Object.assign(LocationUtil, {
    isGDSEnabled : function(){
        return __GDSLocations__.length !== 0;
    },

    isGDSLocationByCity : function(cityCode){
        return SearchModuleUtil.getCurrentModuleName() === 'abroadFlight' && $.inArray(cityCode, __GDSLocations__) != -1;

    },

    isGDSLocation : function(){
        var cityName = jQuery("." + SearchModuleUtil.calculateModule()).find(".destElementClz").val();
        var cityCode = $.LocationUtil.getTranslateCityCodeFromCityName(cityName);
        // console.log(__GDSLocations__)
        return  $.LocationUtil.isGDSLocationByCity(cityCode);

    },

    getTranslateCityCodeFromCityName : function(cityName){
        if (typeof cityName !== 'string' || cityName.length < 1)
            return '';

        var cityNameEscaped = cityName.replace("'", "&#39;");
        if ($("li[data-name='"+ cityNameEscaped +"']").length > 0){
            return $("li[data-name='"+ cityNameEscaped +"']").first().attr("data-code");
        }
        return $("figure[data-name='"+ cityNameEscaped +"']").first().attr("data-code");
    },

    addGDSLocation : function (cityCode) {
        __GDSLocations__.push(cityCode)
    }
});